import { FlowComponent } from '../../../flow.min.js';
import styles from './styles.js';
import { tailwindSheet, baseStyles } from '../../../_shared/styles.js';
import { uiChannel } from '../../../stores/index.js';

const template = FlowComponent.html`
    <div id="loader-overlay" class="loader-overlay">
        <div class="sk-cube-grid">
            <div class="sk-cube sk-cube1 bg-brilliant-azure-500"></div>
            <div class="sk-cube sk-cube2 bg-brilliant-azure-500"></div>
            <div class="sk-cube sk-cube3 bg-brilliant-azure-500"></div>
            <div class="sk-cube sk-cube4 bg-brilliant-azure-500"></div>
            <div class="sk-cube sk-cube5 bg-brilliant-azure-500"></div>
            <div class="sk-cube sk-cube6 bg-brilliant-azure-500"></div>
            <div class="sk-cube sk-cube7 bg-brilliant-azure-500"></div>
            <div class="sk-cube sk-cube8 bg-brilliant-azure-500"></div>
            <div class="sk-cube sk-cube9 bg-brilliant-azure-500"></div>
        </div>
        <p id="loader-message" class="text-white text-lg font-medium mt-6 tracking-wide drop-shadow-md">${'loaderMessage'}</p>
    </div>
`;

export class FlowLoader extends FlowComponent {
    static get styles() { return [tailwindSheet, baseStyles, styles]; }
    static get template() { return template; }

    onMount() {
        super.onMount();
        const overlay = this.root.getElementById('loader-overlay');

        // Nos suscribimos al canal de UI para escuchar el estado del loader
        uiChannel.bind(this, (el, state) => {
            if (state.isLoading) {
                overlay.classList.add('active');
                // Sincronizamos el mensaje
                this.setAttribute('loaderMessage', state.loaderMessage || 'Cargando...');
            } else {
                overlay.classList.remove('active');
            }
        });
    }
}

customElements.define('flow-loader', FlowLoader);